import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { SidebarNavigation } from '../../components/SidebarNavigation';

export const OnePageSectionsNavigation: FC = () => {
  const { t } = useTranslation();
  const isMarketAndSalesDisabled = !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.MARKET_AND_SALES);
  const isTeamDisabled = !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.TEAM);
  const isFinancialProjectionsDisabled = !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS);
  const isFinancingNeedsDisabled = !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.FINANCING_NEEDS);
  const isImplementationPlanDisabled = !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN);

  const options = [
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY}`),
      name: ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY,
      disabled: !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.ABOUT_THE_COMPANY),
    },
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT}`),
      name: ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT,
      disabled: !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.ABOUT_THE_PROJECT),
    },
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.PRODUCTS_SERVICES}`),
      name: ONE_PAGE_SECTIONS.PRODUCTS_SERVICES,
      disabled: !useCheckSubSectionAccess(ONE_PAGE_SECTIONS.PRODUCTS_SERVICES),
    },
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.MARKET_AND_SALES}`),
      name: ONE_PAGE_SECTIONS.MARKET_AND_SALES,
      disabled: isMarketAndSalesDisabled,
      isIconToTheRight: isMarketAndSalesDisabled,
    },
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.TEAM}`),
      name: ONE_PAGE_SECTIONS.TEAM,
      disabled: isTeamDisabled,
      isIconToTheRight: isTeamDisabled,
    },
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS}`),
      name: ONE_PAGE_SECTIONS.FINANCIAL_PROJECTIONS,
      disabled: isFinancialProjectionsDisabled,
      isIconToTheRight: isFinancialProjectionsDisabled,
    },
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.FINANCING_NEEDS}`),
      name: ONE_PAGE_SECTIONS.FINANCING_NEEDS,
      disabled: isFinancingNeedsDisabled,
      isIconToTheRight: isFinancingNeedsDisabled,
    },
    {
      label: t(`chapters.${ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN}`),
      name: ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN,
      disabled: isImplementationPlanDisabled,
      isIconToTheRight: isImplementationPlanDisabled,
    },
  ];

  return <SidebarNavigation options={options} />;
};
